import React from "react";
import { Button, Icon } from "../../Component";

const MedicalPartnerListBulkBar = ({
  selectedCount,
  busy,
  onApprovePending,
  onSetInactive,
  onClear,
}) => {
  if (!selectedCount) return null;

  return (
    <div className="card-inner border-bottom py-2 d-flex flex-wrap align-items-center gap-2 medical-partner-list__bulk-bar">
      <span className="text-dark small font-weight-bold mr-2">
        {selectedCount} selected
      </span>
      <Button color="success" size="sm" type="button" disabled={busy} onClick={onApprovePending}>
        <Icon name="check-circle" className="mr-1" />
        Approve pending (selection)
      </Button>
      <Button color="warning" size="sm" type="button" disabled={busy} onClick={onSetInactive}>
        <Icon name="cross-sm" className="mr-1" />
        Set inactive (selection)
      </Button>
      <Button color="light" size="sm" type="button" disabled={busy} onClick={onClear}>
        Clear
      </Button>
    </div>
  );
};

export default MedicalPartnerListBulkBar;
